var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaveGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leave_Group",
    "data-name": "Leave Group",
    transform: "translate(0 3.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40545",
    "data-name": "Path 40545",
    d: "M22.63,0H2.37A2.506,2.506,0,0,0,0,2.623V22.377A2.506,2.506,0,0,0,2.37,25H22.63A2.506,2.506,0,0,0,25,22.377V2.623A2.506,2.506,0,0,0,22.63,0Zm-11.7,5.626A1.409,1.409,0,0,1,12.259,7.1a1.409,1.409,0,0,1-1.332,1.474A1.409,1.409,0,0,1,9.594,7.1,1.409,1.409,0,0,1,10.927,5.626Zm1.826,7.768h-1.36a1.658,1.658,0,0,1-1.544-1.3L9.1,14.126l1.121.787a2.681,2.681,0,0,1,1.008,2.03V18.49a.815.815,0,0,1-.719.884.815.815,0,0,1-.719-.884V16.944a1.071,1.071,0,0,0-.34-.687L7.845,15.128a1.384,1.384,0,0,0-.3-.16,1.293,1.293,0,0,0-.026.252v1.061a1.693,1.693,0,0,1-1.461,1.743L3.933,18.2a.781.781,0,0,1-.85-.726.813.813,0,0,1,.743-.86l2.121-.177a.173.173,0,0,0,.132-.157V15.22a2.788,2.788,0,0,1,.255-1.19l1.421-3.863H6.843a.983.983,0,0,0-.652.383l-.567.925a.72.72,0,0,1-1.044.284.906.906,0,0,1-.146-1.179L5,9.655A2.365,2.365,0,0,1,6.843,8.575H8.96a2.36,2.36,0,0,1,1.607.564,3.366,3.366,0,0,1,.589,1.691l.075.8a.2.2,0,0,0,.166.166h1.36a.8.8,0,1,1,0,1.592Zm8.652.621-2.37,1.514V13.859h-3.07V11.143h3.07V9.474l2.37,1.514,2.37,1.514L21.4,14.015Z",
    transform: "translate(0 -3.205)",
    fill: "#3d7cc9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveGroup);
export default __webpack_public_path__ + "static/media/leaveGroup.4c421ff6dfa48131551ccbeeb18cd134.svg";
export { ForwardRef as ReactComponent };